import axios from 'axios';
import { getToken, logout } from './auth';

// Define the base URL for the API
const API_URL = import.meta.env.VITE_API_BASE_URL;

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    console.log('[API REQUEST] Token before request:', token);
    if (token) {
      config.headers.Authorization = `Token ${token}`;
      console.log('[API REQUEST] Auth token present:', token.substring(0, 8) + '...');
    } else {
      console.log('[API REQUEST] No auth token found');
    }
    // Debug: log all outgoing requests and headers
    console.log('[API REQUEST]', config.method?.toUpperCase(), config.url, config.headers);
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Debug: log error details and token state
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem('token');
      console.warn('[AXIOS 401] Unauthorized response for URL:', error.config?.url);
      console.warn('[AXIOS 401] Token in localStorage before logout:', token);
      console.warn('[AXIOS 401] Full error object:', error);
      logout();
      window.location = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
